<template>
  <v-btn icon
         rounded
         :v-bind="$attrs"
         @click.prevent="$emit('updated')">
    <v-icon>
      fal fa-fw fa-redo
    </v-icon>
  </v-btn>
</template>
<script>
export default {
  name: 'refresh-button',
}
</script>
